var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#8d98a8",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.35913 2.83287C9.43266 1.75771 11.1732 1.75639 12.2467 2.82992L12.9719 3.55509C14.0363 4.61946 14.0467 6.3432 12.9953 7.42197L7.59513 12.9625C6.88898 13.6871 5.92058 14.0956 4.90964 14.0956L4.01704 14.0956C2.73847 14.0955 1.71791 13.0302 1.77169 11.7517L1.81217 10.7892C1.85169 9.84962 2.24236 8.95891 2.90679 8.29347L8.35913 2.83287ZM11.1865 3.89179C10.6985 3.40382 9.90736 3.40442 9.41939 3.89313L8.95909 4.35412L11.457 6.85201L11.9223 6.37463C12.4002 5.88428 12.3955 5.10076 11.9117 4.61695L11.1865 3.89179ZM3.96705 9.35373L7.89884 5.41599L10.4095 7.92669L6.52213 11.9152C6.09845 12.3499 5.5174 12.5951 4.91084 12.595L4.01824 12.595C3.59205 12.595 3.25187 12.2399 3.26979 11.8137L3.31028 10.8512C3.33399 10.2874 3.56839 9.753 3.96705 9.35373ZM13.6751 14.0467C14.0892 14.0467 14.4248 13.7108 14.4248 13.2965C14.4248 12.8821 14.0892 12.5462 13.6751 12.5462H9.59398C9.17993 12.5462 8.84427 12.8821 8.84427 13.2965C8.84427 13.7108 9.17993 14.0467 9.59398 14.0467H13.6751Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.b0ef0ad6d4124014d1f79df332a97d8a.svg";
export { ForwardRef as ReactComponent };